import React, { Component, Fragment } from "react";
import Button from "../../../../components/atoms/Button";
import InformasiDokumen from "../PengajuanPinjaman/InformasiDokumen";
import DataJaminan from "../PengajuanPinjaman/DataJaminan";
import RiwayatNegosiasi from "../PengajuanPinjaman/RiwayatNegosiasi";
import DataPinjaman from "./DataPinjaman";
import RiwayatStatus from "./RiwayatStatus";
import RiwayatMemo from "./RiwayatMemo";
import RincianPembayaran from "../PengajuanPinjaman/RincianPembayaran";

let statusRincianPembayaran = ["DS1", "WD1", "PD1", "CC0", "CP1", "NPL"];

export default ({ statusBtn, changeBtn, dataDetail, LoanGrade, history }) => {
	const sortDate = (date) => {
		let sortDate = date.sort(function (a, b) {
			return new Date(b.createdAt) - new Date(a.createdAt);
		});
		console.log({ date, sortDate });

		return date;
	};
	return (
		<div>
			<div className="bg-vertical-scroll bg-button-vertical">
				{statusBtn.map((value, index) => {
					return (
						<Fragment key={index}>
							{value.status ? (
								<Button title={value.title} type={"button"} color="yellow" width="small-rounded" onClick={() => changeBtn(index)} />
							) : (
								<Button title={value.title} type={"button"} color="yellow" width="small-rounded outline" onClick={() => changeBtn(index)} />
							)}
						</Fragment>
						// </div>
					);
				})}
			</div>
			<div className="card-data-pinjaman">
				{statusBtn.map((value, index) => {
					if (value.status) {
						if (value.key === "DataPinjaman") {
							return <DataPinjaman key={index} title={value.title} dataDetail={dataDetail} LoanGrade={LoanGrade} history={history} />;
						} else if (value.key === "InformasiDokumen") {
							return <InformasiDokumen key={index} title={value.title} infoDocs={dataDetail.infoDocs} agreementDocs={dataDetail.loanAgreement} />;
						} else if (value.key === "DataJaminan") {
							return <DataJaminan key={index} title={value.title} infoCollateral={dataDetail.infoCollateral} />;
						} else if (value.key === "RiwayatNegosiasi") {
							return <RiwayatNegosiasi key={index} title={value.title} offeringHistory={sortDate(dataDetail.offeringHistory)} />;
						} else if (value.key === "RiwayatStatus") {
							return <RiwayatStatus key={index} title={value.title} statusHistory={dataDetail.statusHistory} />;
						} else if (value.key === "RiwayatMemo") {
							return <RiwayatMemo key={index} title={value.title} memoHistory={dataDetail.memoHistory} />;
						} else if (value.key === "RincianPembayaran") {
							return <RincianPembayaran key={index} title={value.title} dataDetail={dataDetail} />;
						}
					}
				})}
			</div>
		</div>
	);
};
